import Vue from 'vue';
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import BootstrapVue from 'bootstrap-vue';

Vue.component(FeatherIcon.name, FeatherIcon);

Vue.use(BootstrapVue);

Vue.component('b-select-filter', () =>
  import('@core/components/b-select-filter')
);

import { BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css';

Vue.use(BootstrapVueIcons);

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    // key: "AIzaSyAnEWbvXzcNHxZsvJh0Ox_WDU_B1rgX5oU",
    key: 'AIzaSyCBMvvmT_durKZuk1pqSvoizzCr2vZ9mCQ',

    libraries: 'places', //necessary for places input
  },
});

import CustomGoogleAutocomplete from 'vue-custom-google-autocomplete';
Vue.use(CustomGoogleAutocomplete);
import VueGoodTablePlugin from 'vue-good-table';
// import the styles
import 'vue-good-table/dist/vue-good-table.css';

Vue.use(VueGoodTablePlugin);
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.use(flatPickr);

import ScrollLoader from 'vue-scroll-loader';

Vue.use(ScrollLoader);

import DatePicker from 'vue2-datepicker';

Vue.component('DatePicker', DatePicker);

import 'vue2-datepicker/index.css';

import VuePerfectScrollbar from 'vue-perfect-scrollbar';

Vue.component('VuePerfectScrollbar', VuePerfectScrollbar);

import Cleave from 'vue-cleave-component';

Vue.component('Cleave', Cleave);
import { quillEditor } from 'vue-quill-editor';
Vue.component('quill-editor', quillEditor);

import Select3 from '@core/components/Select3';

Vue.component('Select3', Select3);

import Select4 from '@core/components/Select4';

Vue.component('Select4', Select4);


import selectCheckbox from '@core/components/select-checkbox';

Vue.component('SelectCheckbox', selectCheckbox);

import DateTimeV2 from '@core/components/date-time-v2';

Vue.component('DateTimeV2', DateTimeV2);

import SelectSchedule from '@core/components/select-schedule';

Vue.component('SelectSchedule', SelectSchedule);


import SelectView from '@core/components/select-view';

Vue.component('SelectView', SelectView);

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)



//SelectMutile 
import SelectMultiple from '@core/components/SelectMultiple';

Vue.component('SelectMultiple', SelectMultiple);
